import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
  const cities = ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Miami'];
  const specialties = ['Primary Care', 'Cardiology', 'Dermatology', 'Orthopedics', 'Pediatrics'];

  return (
    <footer className="bg-gray-50 border-t border-gray-200" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-teal-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">M</span>
              </div>
              <span className="font-heading font-bold text-xl text-gray-900">MedSearcher</span>
            </Link>
            <p className="text-gray-600 text-sm mb-4">
              Find trusted healthcare providers near you. Compare facilities, specialists, and pharmacies all in one place.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-teal-700 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-700 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-700 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Top Cities */}
          <div>
            <h3 className="font-heading font-semibold text-gray-900 mb-4">Top Cities</h3>
            <ul className="space-y-2">
              {cities.map((city) => (
                <li key={city}>
                  <Link
                    to={`/city/${city.toLowerCase().replace(' ', '-')}`}
                    className="footer-link flex items-center gap-2"
                  >
                    <MapPin className="w-4 h-4" />
                    {city}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Top Specialties */}
          <div>
            <h3 className="font-heading font-semibold text-gray-900 mb-4">Top Specialties</h3>
            <ul className="space-y-2">
              {specialties.map((specialty) => (
                <li key={specialty}>
                  <Link
                    to={`/specialty/${specialty.toLowerCase().replace(' ', '-').replace('/', '-')}`}
                    className="footer-link"
                  >
                    {specialty}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Links */}
          <div>
            <h3 className="font-heading font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2 mb-6">
              <li>
                <Link to="/add-listing" className="footer-link">Add Your Listing</Link>
              </li>
              <li>
                <Link to="/pricing" className="footer-link">Pricing Plans</Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">Contact</Link>
              </li>
            </ul>
            <div className="space-y-2 text-sm text-gray-600">
              <a href="mailto:support@medsearcher.com" className="flex items-center gap-2 hover:text-teal-700">
                <Mail className="w-4 h-4" />
                support@medsearcher.com
              </a>
              <a href="tel:+18001234567" className="flex items-center gap-2 hover:text-teal-700">
                <Phone className="w-4 h-4" />
                1-800-123-4567
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} MedSearcher. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-teal-700">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-teal-700">Terms of Service</Link>
            <Link to="/accessibility" className="text-sm text-gray-500 hover:text-teal-700">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
